import React from "react";
import ImageButton from "../../script/common/ImageButton";
import image from "../../image/Buttons/MarketScene/market_scene.png";
import hoverImage from "../../image/Buttons/MarketScene/market_scene_hv.png";
import clickImage from "../../image/Buttons/MarketScene/market_scene_click.png";

interface Props {
  isDisabled: boolean;
  onClick: () => void;
}

const MarketSceneButton = ({ isDisabled, onClick }: Props) => {
  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        width: "auto",
        height: "100%",
        aspectRatio: "114 / 74",
        transform: "translate(-50%, -50%)",
        margin: "0px",
      }}
    >
      <ImageButton
        onClick={onClick}
        isDisabled={isDisabled}
        defaultImagePath={image}
        hoverImagePath={hoverImage}
        clickedImagePath={clickImage}
        disabledImagePath={clickImage}
      />
    </div>
  );
};

export default MarketSceneButton;
